/* eslint-disable import/prefer-default-export */
// import moment from 'moment';
import { TRACKING_KEY, TRACKING_EVENT } from 'shared/constants';
import ultilitiesService from 'shared/util/ultilitiesService';

export const trackCTA = (tracking, value) => {
  const body = {
    event: TRACKING_EVENT.SELECT,
    key: TRACKING_KEY.CTA,
    value,
    index: true,
    complex: false,
  };
  tracking.trackEvent(body);
};

export const trackAvisorAppointment = (tracking, appointment) => {
  const body = {
    event: TRACKING_EVENT.PAYLOAD,
    key: TRACKING_KEY.ADVISOR_APPOINTMENT,
    index: true,
    complex: true,
  };
  body.value = ultilitiesService.stringBuilder(appointment);
  tracking.trackEvent(body);
};

export const trackCompleteProspect = (tracking, summary) => {
  const body = {
    event: TRACKING_EVENT.PAYLOAD,
    key: TRACKING_KEY.COMPLETE_PROSPECT,
    index: true,
    complex: true,
  };
  body.value = ultilitiesService.stringBuilder(summary);
  tracking.trackEvent(body);
};
